import { FC, ReactElement } from "react"
import { useFormikContext } from "formik"

import { useTranslation } from "react-i18next"

import { formatFiatCurrency } from "../../../util/formatter"
import { DropdownMenu } from "../../inputs/DropdownMenu"
import { InputField } from "../../inputs/InputField"

import { FormValuesType } from "./ModalPromoCode"

export const ActivityRequirements: FC = (): ReactElement => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const { values, handleChange, setFieldValue } = useFormikContext<FormValuesType>()

  const handlePeriodChange = (e: { target: { value: string } }) => {
    const val = e.target.value
    setFieldValue("activity_period_days", val ? Number(val) : null)
  }

  const periodOptions = [
    { name: t("promo.days7"), value: "7" },
    { name: t("promo.days14"), value: "14" },
    { name: t("promo.days30"), value: "30" }
  ]

  const amountFields = [
    { name: "min_deposit_amount_usd", title: t("promo.minDeposit"), value: values.min_deposit_amount_usd },
    { name: "min_wager_amount_usd", title: t("promo.minWager"), value: values.min_wager_amount_usd }
  ]

  return (
    <div className="mt-5">
      <p className="text-sm font-semibold mb-2">{t("promo.activityRequirements")}</p>
      <div className="flex flex-row space-x-4">
        <div className="w-full">
          <DropdownMenu
            title={t("promo.periodDays")}
            placeholder={t("promo.noPeriod")}
            options={periodOptions}
            value={values.activity_period_days?.toString() ?? ""}
            onChange={handlePeriodChange}
            name="activity_period_days"
            id="activity_period_days"
          />
        </div>
      </div>
      {values.activity_period_days && (
        <div className="flex flex-row space-x-4 mt-3">
          {amountFields.map(({ name, title, value }) => (
            <div key={name} className="w-full">
              <InputField
                id={name}
                name={name}
                title={title}
                altLabelOne={formatFiatCurrency(value ?? undefined, "$0.00")}
                type="number"
                value={value ?? ""}
                onChange={handleChange}
              />
            </div>
          ))}
        </div>
      )}
      {values.activity_period_days && (values.min_deposit_amount_usd || values.min_wager_amount_usd) && (
        <p className="text-xs text-yellow-400 mt-2">{t("promo.activityHint", { days: values.activity_period_days })}</p>
      )}
    </div>
  )
}
